import { Injectable } from '@angular/core';
import { Tablet } from '@ng-cloud/badger-core/models/tablet';
import { ApiService } from '@ng-cloud/badger-core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabletService extends ApiService {

  /**
   * Lookup tablet by the tablet's model and serial number
   */
  lookupTablet(model: string, serial_number: string): Observable<Tablet> {
    const params = { model, serial_number };
    return this.get(Tablet, `tablets/lookup`, 600, params);
  }

  /**
   * Lookup tablet by the robot id
   */
  showTabletByRobot(robot_id: number): Observable<Tablet> {
    return this.get(Tablet, `robots/${robot_id}/tablet`, 600);
  }
}
